import {AnyObject} from 'types';

export function memoizeOne<T, K = string | number | AnyObject>(func: (key: K) => T) {
  let previous: K;
  let result: T;
  return (key: K) => {
    if (key !== previous) {
      previous = key;
      result = func(key);
    }
    return result;
  };
}
